module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoB.2195722.woff";